import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { IktatgatoLayoutComponent } from './iktatgato-layout/iktatgato-layout.component';
import { IktAttekintesComponent } from './attekintes/attekintes.component';
import { IktErkeztetesComponent } from './erkeztetes/erkeztetes.component';
import { IktIktatasComponent } from './iktatas/iktatas.component';
import { IktUgyiratokComponent } from './ugyiratok/ugyiratok.component';
import { IktUgyiratComponent } from './ugyirat/ugyirat.component';
import { IktIratComponent } from './irat/irat.component';
import { IktKonyvekComponent } from './konyvek/konyvek.component';
import { IktIrattarComponent } from './irattar/irattar.component';
import { IktPostakonyvComponent } from './postakonyv/postakonyv.component';
import { IktBeallitasokComponent } from './beallitasok/beallitasok.component';
import { IktSulinformComponent } from './sulinform/sulinform.component';
import { IktKeresesComponent } from './kereses/kereses.component';
import { IktRiportComponent } from './riport/riport.component';
import { IktPartnerekComponent } from './partnerek/partnerek.component';
import { IktFeladatokComponent } from './feladatok/feladatok.component';
import { IktPeldanyokComponent } from './peldanyok/peldanyok.component';
import { IktKuldesComponent } from './kuldes/kuldes.component';
import { IktBkszComponent } from './bksz/bksz.component';
import { IktKuldemenyekComponent } from './kuldemenyek/kuldemenyek.component';
import { IktKezbesitesComponent } from './kezbesites/kezbesites.component';

/**
 *  IKTATGATÓ – intézményi iratkezelő feature-modul.
 *  A CAESAR mintájára saját IonicModule importtal, mert a routing az
 *  app-routing.module-ban direkt komponens-referenciákkal tölti be.
 */
const KOMPONENSEK = [
  IktatgatoLayoutComponent, IktAttekintesComponent, IktErkeztetesComponent,
  IktIktatasComponent, IktUgyiratokComponent, IktUgyiratComponent, IktIratComponent,
  IktKonyvekComponent, IktIrattarComponent, IktPostakonyvComponent, IktBeallitasokComponent,
  IktSulinformComponent, IktKeresesComponent, IktRiportComponent,
  IktPartnerekComponent, IktFeladatokComponent, IktPeldanyokComponent,
  IktKuldesComponent, IktBkszComponent, IktKuldemenyekComponent, IktKezbesitesComponent,
];

@NgModule({
  declarations: KOMPONENSEK,
  imports: [CommonModule, FormsModule, RouterModule, IonicModule],
  exports: KOMPONENSEK,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IktatgatoModule {}
